
  const colourStyles =  {
    control: (styles) => ({ ...styles, backgroundColor: 'white !important',borderRadius:'8px',borderColor:'#E5E5E5' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? '#40ba47'
          : isFocused
          ?  '#e1ffed'
          : undefined,
        borderColor: isDisabled
          ? undefined
          : isSelected
          ? '#00000'
          : isFocused
          ?  '#00000'
          : undefined,
        color: isDisabled
          ? '#575757'
          : isSelected
          ? '#575757'
          : isFocused
          ? '#40ba47'
          : '#575757',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
  
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? '#40ba47'
              :  '#40ba47'
            : undefined,
        },
      };
    },
    multiValue: (styles, { data }) => {
      const color ="red";
      return {
        ...styles,
        borderColor: "#00b048" ,
        backgroundColor: '#40ba47',
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#ffffff",
      borderRadius: "2px 0 0 2px",
      backgroundColor: '#40ba47',
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#ffffff",
      borderRadius: "0 2px 2px 0",
      backgroundColor: '#008839',
      ':hover': {
        backgroundColor: '#40ba47',
        color: 'white',
      },
    }),
};




export default colourStyles;